import { useTicketTemplateQuery } from "@ticketingplatform/api/dist/ticketTemplate";

import { UseTicketTemplateTicketPools } from "./types";

export const useTicketTemplateTicketPools: UseTicketTemplateTicketPools = (
  ticketTemplateId?: number
) => {
  const { data, loading } = useTicketTemplateQuery({
    variables: {
      id: ticketTemplateId || 0,
    },
    skip: !ticketTemplateId,
  });

  return {
    ticketPools:
      data?.ticketTemplate?.ticketPools?.nodes.map(
        ({ hasAnyTicketSold, ...ticketPool }) => ({
          ...ticketPool,
          hasAnyTicketSold: !!hasAnyTicketSold,
        })
      ) || undefined,
    loading,
  };
};
